// extracted by mini-css-extract-plugin
module.exports = {"root":"e_cnb","loading":"e_dnb"};